export default __webpack_public_path__ + "static/media/background.4384177d.png";